export function getTimeOfDayGreeting() {
  const today = new Date();
  const currentHour = today.getHours();

  if (currentHour < 12) {
    return "Good morning";
  } else if (currentHour < 18) {
    return "Good afternoon";
  } else {
    return "Good evening";
  }
}

export const minutes = 60 * 1000; // in ms
export const seconds = 1000; // in ms
